export const isNonEmptyArray = (array = []) => array instanceof Array && array.length;
